import { cn } from "cy-fe/src/utils/cn";
import { NextLink } from "cy-fe";

export function SendMoneyLink({
  href,
  onClick,
}: {
  href: string;
  onClick: () => void;
}) {
  return (
    <NextLink
      className={cn(
        "bg-button-primary rounded-full px-6 py-1 text-sm font-semibold text-white",
      )}
      href={href}
      onClick={onClick}
    >
      <span>Send Money</span>
    </NextLink>
  );
}
